// Presentation only: pricing continues to use the original English market/type keys.
export function readPreferences(search) {
  const params = new URLSearchParams(search);
  const language = (params.get("lang") || "").trim().toLowerCase();
  const requestedTheme = (params.get("theme") || "").trim().toLowerCase();
  return {
    lang: ["ar", "arabic"].includes(language) ? "ar" : "en",
    theme: ["light", "dark", "system"].includes(requestedTheme) ? requestedTheme : "light",
    headless: (params.get("headless") || "").trim().toLowerCase() === "true",
  };
}

const arabic = {
  "Your Country": "بلدك",
  "Choose country": "اختر البلد",
  "Nothing found.": "لم يتم العثور على نتائج.",
  "monthly": "شهريًا",
  "Marketing Message": "رسائل التسويق",
  "Utility Message": "الرسائل الخدمية",
  "Authentication Message": "رسائل المصادقة",
  "Authentication – International Message": "رسائل المصادقة الدولية",
  "Service Message": "رسائل خدمة العملاء",
  "Marketing Message Cost": "تكلفة رسائل التسويق",
  "Utility Message Cost": "تكلفة الرسائل الخدمية",
  "Authentication Message Cost": "تكلفة رسائل المصادقة",
  "Authentication – International Message Cost": "تكلفة رسائل المصادقة الدولية",
  "Service Message Cost": "تكلفة رسائل خدمة العملاء",
  "Not applicable for": "غير متاح في",
  "Your WhatsApp Business cost per month for": "تكلفة واتساب للأعمال الشهرية في",
  "Total Message Cost": "إجمالي تكلفة الرسائل",
  "Hide Details": "إخفاء التفاصيل",
  "View Details": "عرض التفاصيل",
  "Free": "مجاني",
  "Revora Processing Fee": "رسوم معالجة ريفورا",
  "Total WhatsApp Message Cost": "إجمالي تكلفة رسائل واتساب",
  "Tiered Breakdown:": "تفاصيل شرائح التسعير:",
  "messages": "رسالة",
  "msg": "رسالة",
  "discount": "خصم",
  "Average Rate:": "متوسط السعر:",
  "unlimited": "بلا حد"
};

export const arabicMarkets = {
  "Argentina": "الأرجنتين",
  "Bangladesh": "بنغلاديش",
  "Brazil": "البرازيل",
  "Chile": "تشيلي",
  "Colombia": "كولومبيا",
  "Egypt": "مصر",
  "France": "فرنسا",
  "Germany": "ألمانيا",
  "Hong Kong": "هونغ كونغ",
  "Hungary": "المجر",
  "India": "الهند",
  "Indonesia": "إندونيسيا",
  "Iraq": "العراق",
  "Italy": "إيطاليا",
  "Kazakhstan": "كازاخستان",
  "Kuwait": "الكويت",
  "Malaysia": "ماليزيا",
  "Mexico": "المكسيك",
  "Morocco": "المغرب",
  "Nepal": "نيبال",
  "Netherlands": "هولندا",
  "Nigeria": "نيجيريا",
  "Oman": "عُمان",
  "Pakistan": "باكستان",
  "Peru": "بيرو",
  "Poland": "بولندا",
  "Qatar": "قطر",
  "Romania": "رومانيا",
  "Russia": "روسيا",
  "Saudi Arabia": "المملكة العربية السعودية",
  "Singapore": "سنغافورة",
  "South Africa": "جنوب أفريقيا",
  "Spain": "إسبانيا",
  "Sri Lanka": "سريلانكا",
  "Turkey": "تركيا",
  "Ukraine": "أوكرانيا",
  "United Arab Emirates": "الإمارات العربية المتحدة",
  "United Kingdom": "المملكة المتحدة",
  "North America": "أمريكا الشمالية",
  "Rest of Africa": "بقية أفريقيا",
  "Rest of Asia Pacific": "بقية آسيا والمحيط الهادئ",
  "Rest of Central & Eastern Europe": "بقية أوروبا الوسطى والشرقية",
  "Rest of Latin America": "بقية أمريكا اللاتينية",
  "Rest of Middle East": "بقية الشرق الأوسط",
  "Rest of Western Europe": "بقية أوروبا الغربية",
  "Other": "أخرى"
};

export function calculatorLocale(lang) {
  const isArabic = lang === "ar";
  const number = (value) => Number(value).toLocaleString(isArabic ? "ar-u-nu-arab" : "en-US");
  const t = (text) => isArabic ? arabic[text] || text : text;
  return {
    t,
    number,
    // Keep USD and four decimals, as before. bdi isolates amounts in RTL copy.
    money: (value) => "$" + Number(value).toFixed(4).replace(/[0-9.]/g,
      (character) => isArabic
        ? character === "." ? "٫" : "٠١٢٣٤٥٦٧٨٩"[Number(character)]
        : character),
    market: (name) => isArabic ? arabicMarkets[name] || name : name,
    range: (value) => value.replace(/unlimited/g, t("unlimited")).replace(/[0-9]/g,
      (digit) => isArabic ? "٠١٢٣٤٥٦٧٨٩"[Number(digit)] : digit),
    serviceHint: (count) => isArabic
      ? `ردود على المحادثات التي يبدأها العملاء. أول ${count} رسالة شهريًا مجانية.`
      : `Replies to customer-initiated chats. First ${count} per month are free.`,
    aboveFree: (count, allowance) => isArabic
      ? `${count} رسالة تتجاوز حد الرسائل المجانية البالغ ${allowance}`
      : `${count} messages above the ${allowance} free`,
  };
}
